/**
 * 用户信息相关API
 */
import http from './http.js';


export default class CompanyAPI {
    static save(data) {
        return http.httpPost('company', data);
    }

   
    static getCompany() {
        return http.httpGet('company');
    }

    static getIndustries(){
        return http.httpGet('industry/list');
    }
}


// WEBPACK FOOTER //
// ./app/api/company.api.js